import { useQuery } from '@apollo/client';
import FETCH_ORGANIZATIONS from 'src/graphql/querys/fetchOrganizations';

const useOrganizations = () => {
  const { data, loading, refetch } = useQuery(FETCH_ORGANIZATIONS);
  // Se mantiene el retorno laxo (any) a propósito: varios consumidores fuera de este
  // scope (OrganizationSelect, AccessSystems, CreateGate, OrganizationAccess, billing)
  // dependen de esta forma y tienen useState sin tipar; tiparlo con el tipo GQL
  // generado los rompería — deuda propia de esos componentes, fuera de AMARU-488.
  const organizations: any = data?.organizations ?? [];
  return { organizations, loading, refetch };
};

export default useOrganizations;
